import { useCallback } from 'react';

import './style.scss';
import { Dropdown } from 'react-bootstrap';
import { useRepriceQuotes } from 'routes/smart-quote/hooks/use-reprice-quotes';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';
import { SmartQuoteParsingResult } from 'state/workspaces/smart-quote/model';

type OpenInWorkspacesProps = {
  results: SmartQuoteParsingResult[];
};

export function OpenInWorkspaces({ results }: OpenInWorkspacesProps) {
  const { reloadInAdvanced, reloadInBatch, openInQuoteBlotter } = useRepriceQuotes();

  const openInAdvancedWorkspace = useCallback(() => {
    results.forEach(({ rfqId, externalQuoteId }) => {
      reloadInAdvanced(rfqId, externalQuoteId);
    });
    trackSmartQuoteEvent('quote actions', 'open in advanced workspace');
  }, [results, reloadInAdvanced]);

  const openInBatchWorkspace = useCallback(() => {
    reloadInBatch(results);
    trackSmartQuoteEvent('quote actions', 'open in batch workspace');
  }, [reloadInBatch, results]);

  const handleOpenInQuoteBlotter = useCallback(() => {
    openInQuoteBlotter(results);
    trackSmartQuoteEvent('quote actions', 'open in quote blotter');
  }, [openInQuoteBlotter, results]);

  return (
    <Dropdown drop="up">
      <Dropdown.Toggle className="btn btn-flat-secondary btn-icon-start dropdown-toggle openInBtn">
        <i className="icon icon-outlined" aria-hidden="true">
          open_in_new
        </i>
        Open in
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={openInAdvancedWorkspace}>
          <div className="d-flex align-items-center justify-content-between gap-2">
            Advanced workspace
            <i className="icon icon-outlined" aria-hidden="true">
              open_in_new
            </i>
          </div>
        </Dropdown.Item>
        <Dropdown.Item onClick={openInBatchWorkspace}>
          <div className="d-flex align-items-center justify-content-between gap-2">
            Batch workspace
            <i className="icon icon-outlined" aria-hidden="true">
              open_in_new
            </i>
          </div>
        </Dropdown.Item>
        <Dropdown.Item onClick={handleOpenInQuoteBlotter}>
          <div className="d-flex align-items-center justify-content-between gap-2">
            Quote blotter
            <i className="icon icon-outlined" aria-hidden="true">
              open_in_new
            </i>
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
